import { createFileRoute } from "@tanstack/react-router";
import { JobTypeRulesSection } from "./fullRules";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/jobTypes/$jobTypeId/rules",
)({
	component: AdminJobTypeRulesTab,
});

function AdminJobTypeRulesTab() {
	return (
		<div className="px-5 pb-5">
			<JobTypeRulesSection stayOnRoute />
		</div>
	);
}
